import { HiddenColumnsState as HiddenColumnsAllState, ColumnsOrderState as ColumnsOrderAllState, SelectedFiltersState as SelectedFiltersAllState, CHANGE_HIDDEN_COLUMNS_ALL, CHANGE_COLUMNS_ORDER_ALL, CHANGE_SELECTED_FILTERS_ALL } from "../FlightRequestList/types"

export type LocaleState = "en" | "fa";
export type FontState = "tahoma" | "homa" | "yekan";
export type ThemeState = 'theme1' | 'theme2';
export type DirectionState = 'rtl' | 'ltr';
export type LanguageState = 'fa' | 'en';
export type HiddenColumnsState = HiddenColumnsAllState;
export type ColumnsOrderState = ColumnsOrderAllState;
export type SelectedFiltersState = SelectedFiltersAllState;


export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const CHANGE_THEME = 'CHANGE_THEME';
export const CHANGE_FONT = 'CHANGE_FONT';
export const CHANGE_DIRECTION = 'CHANGE_DIRECTION';
export const CHANGE_LARGE_WINDOW = 'CHANGE_LARGE_WINDOW';
export const CHANGE_CALENDAR_VIEW = 'CHANGE_CALENDAR_VIEW';

export interface ChangeThemeAction {
  type: typeof CHANGE_THEME,
  payload: ThemeState,

}
export interface ChangeFontAction {
  type: typeof CHANGE_FONT,
  payload: FontState,
}
export interface ChangeDirectionAction {
  type: typeof CHANGE_DIRECTION,
  payload: DirectionState,
}

export interface ChangeLargeWindowAction {
  type: typeof CHANGE_LARGE_WINDOW,
  payload: boolean,
}
export interface ChangeLocaleAction {
  type: typeof CHANGE_LOCALE,
  payload: LocaleState,
}

export interface ChangeHiddenColumnsAction {
  type: typeof CHANGE_HIDDEN_COLUMNS_ALL,
  payload: { data: HiddenColumnsAllState },
}
export interface ChangeColumnsOrderAction {
  type: typeof CHANGE_COLUMNS_ORDER_ALL,
  payload: { data: ColumnsOrderAllState },
}
export interface ChangeSelectedFiltersAction {
  type: typeof CHANGE_SELECTED_FILTERS_ALL,
  payload: { data: SelectedFiltersAllState },
}

export interface ChangeCalendarViewAction {
  type: typeof CHANGE_CALENDAR_VIEW,
  payload: { data: string },
}


export type ConfigurationsActionTypes =
  ChangeThemeAction
  | ChangeFontAction
  | ChangeDirectionAction
  | ChangeLargeWindowAction
  | ChangeLocaleAction
  | ChangeHiddenColumnsAction
  | ChangeColumnsOrderAction
  | ChangeSelectedFiltersAction
  | ChangeCalendarViewAction


